import React, { useState, useRef, useEffect } from "react";
import "./UserDropdown.css";

interface UserDropdownProps {
  username: string;
  isSuperuser?: boolean;
  onLogout: () => void;
  onManageKnowledge?: () => void;
  onManageUsers?: () => void;
  theme?: "light" | "dark";
}

const UserDropdown: React.FC<UserDropdownProps> = ({
  username,
  isSuperuser = false,
  onLogout,
  onManageKnowledge,
  onManageUsers,
  theme = "light",
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className={`user-dropdown ${theme}`} ref={dropdownRef}>
      <button className="user-dropdown-toggle" onClick={toggleDropdown}>
        {username}
        <span className={`dropdown-arrow ${isOpen ? "open" : ""}`}>▼</span>
      </button>
      {isOpen && (
        <div className="user-dropdown-menu">
          <div className="user-dropdown-username">
            <strong>{username}</strong>
          </div>
          {isSuperuser && onManageKnowledge && (
            <button
              className="user-dropdown-item"
              onClick={() => {
                onManageKnowledge();
                setIsOpen(false);
              }}
            >
              Manage Knowledge Documents
            </button>
          )}
          {isSuperuser && onManageUsers && (
            <button
              className="user-dropdown-item"
              onClick={() => {
                onManageUsers();
                setIsOpen(false);
              }}
            >
              Manage Users
            </button>
          )}
          <button
            className="user-dropdown-item logout"
            onClick={() => {
              onLogout();
              setIsOpen(false);
            }}
          >
            Logout
          </button>
        </div>
      )}
    </div>
  );
};

export default UserDropdown;
